
import { locale } from './globals.js';

class SwiperSlider {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.rtl = (locale.dir == 'rtl')
    this.createSlider()
    this.videoHandler()
    this.slider.init()
    this.el.setAttribute('data-state', 'ready')
  }
  createSlider () {
    let layout = this.el.hasAttribute('data-layout') ? this.el.getAttribute('data-layout') : 'default'
    let autoplay_delay = (this.el.getAttribute('data-autoplay') === 'true') ? 5000 : this.el.getAttribute('data-autoplay')
    let hash = (this.el.getAttribute('data-hash') === 'true') ? { watchState: true } : false
    let goPrevEl = this.el.querySelector('[data-slider-prev]') || this.el.parentNode.querySelector('[data-slider-prev]')
    let goNextEl = this.el.querySelector('[data-slider-next]') || this.el.parentNode.querySelector('[data-slider-next]')
    let options = {
      slidesPerView:  (layout == 'row') ? 'auto' : 1,
      autoplay:       autoplay_delay ? { delay: autoplay_delay, disableOnInteraction: false } : false,
      loop:           this.el.getAttribute('data-loop') === 'true',
      freeMode:       this.el.getAttribute('data-freemode') === 'true',
      hashNavigation: hash,
      speed:          400,
      navigation: {
        prevEl:       goPrevEl,
        nextEl:       goNextEl
      },
      init:           false
    }
    if (this.el.querySelectorAll('.swiper-slide').length < 2) {
      options.autoplay = false
      options.loop = false
    }
    this.slider = new Swiper(this.el, options)
    // if (hash) console.log(this.slider)
    

    this.slider.on('slideChange', function () {
      Array.from(this.slides).forEach((slide, index) => {
        let video = slide.querySelector('video');
        if (!video) return;
        if(index == this.activeIndex) {
          video.play()
        } else {
          video.pause()
        }
      });
    });
    this.slider.on('init', () => {
      // console.log(this.slider)
    })
  }
  videoHandler() {
    this.slider.on('init', function() {
      let video = this.slides[this.activeIndex].querySelector('video')
      if (video) video.play()
    })
    this.slider.on('slideChange', function () {
      Array.from(this.slides).forEach((slide, index) => {
        let video = slide.querySelector('video');
        if (!video) return;
        if(index == this.activeIndex) {
          video.play()
        } else {
          video.pause()
        }
      });
    });
  }
  
}
function init () {
  document.querySelectorAll('[data-swiper-slider]').forEach(elem => {
    if(!elem.hasAttribute('data-state')) new SwiperSlider(elem)
  })
}
document.body.addEventListener('domupdated', () => init())
init()